import Route from 'rise-ui/utils/routing/route.js';

import { service } from '@ember/service';

import riseApiConfig from 'rise-ui/config/rise-api.js';
import { breadcrumb } from 'rise-ui/services/breadcrumb.js';
import { scrollRoot } from 'rise-ui/services/scroll-root.js';

@scrollRoot
export default class RiseApiRoute extends Route {
  @service keywords;

  setHeadTags(model) {
    this.headTags = [
      {
        type: 'meta',
        attrs: {
          name: 'description',
          content: riseApiConfig.metaDescription,
        },
      },
      {
        type: 'meta',
        attrs: {
          name: 'keywords',
          content: this.keywords.keywords(...riseApiConfig.metaKeywordsArgs),
        },
      },
    ];
  }

  @breadcrumb crumbs = 'RISE API';
}
